/* eslint-disable import/no-unresolved */
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import '@/css/common.css'
import request from '@/http/request'
import api from '@/apis/api'
import '@/css/common.scss'
import '@/css/editor.scss'
import '@/css/element-deep.css'
import '@/css/element-ui-all-head-tip.css'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Slider,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Spinner,
  Badge,
  Card,
  Rate,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Cascader,
  ColorPicker,
  Transfer,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Timeline,
  TimelineItem,
  Link,
  Divider,
  Image,
  Calendar,
  Backtop,
  PageHeader,
  CascaderPanel,
  Loading,
  MessageBox,
  Message,
  Notification,
  Avatar,
} from 'element-ui'

import '@/css/element-ui.custom.css'
import preventReClick from './js/preventReClick'

Vue.use(Pagination)
Vue.use(Avatar)
Vue.use(Dialog)
Vue.use(Autocomplete)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Alert)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Spinner)
Vue.use(Badge)
Vue.use(Card)
Vue.use(Rate)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Cascader)
Vue.use(ColorPicker)
Vue.use(Transfer)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Link)
Vue.use(Divider)
Vue.use(Image)
Vue.use(Calendar)
Vue.use(Backtop)
Vue.use(PageHeader)
Vue.use(CascaderPanel)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.prototype.$http = request
Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.use(preventReClick)
/**
 * String.prototype.replaceAll 的兼容写法
 * @param toConvert {string} 需要被转换的指定字符或字符串
 * @param replaceWith {string} 需要被转换成为指定的字符或字符串
 * @param ignoreCase {boolean} 是否区分大小写,默认不传为false
 * @returns {string} 转换后的结果
 * @private
 */
String.prototype.__replaceAll = (toConvert, replaceWith, ignoreCase = false) => {
  if (!RegExp.prototype.isPrototypeOf(toConvert)) {
    try {
      return this.replace(new RegExp(toConvert, ignoreCase ? 'gi' : 'g'), replaceWith)
    } catch (e) {
      return this.replace(toConvert, replaceWith)
    }
  } else {
    return this.replace(toConvert, replaceWith)
  }
}

/**
 * 获取URL指定参数值
 * @param param {string} 参数名称
 * @returns {string|null} 指定参数值
 */
Vue.prototype.$queryUrlParam = param => {
  if (typeof param !== 'string') {
    return null
  }
  const reg = new RegExp(`(^|&)${param}=([^&]*)(&|$)`)
  const r = window.location.search.substr(1).match(reg)

  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/**
 * 进程暂停
 * @param time {number} 暂停毫秒数
 * @returns {Promise<unknown>}
 */
Vue.prototype.$handleSleep = time =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, time)
  })

/**
 * 时间格式化
 * @param time {Date} 时间
 * @param format {string} 时间格式化模板
 * @returns {String} 返回格式化后的时间内容
 */
Vue.prototype.$dateFormat = (time, format) =>
  format.replace(/yyyy|MM|dd|HH|mm|ss/g, str => {
    switch (str) {
      case 'yyyy':
        return new Date(time)
          .getFullYear()
          .toString()
          .padStart(4, '0')
      case 'MM':
        return (new Date(time).getMonth() + 1).toString().padStart(2, '0')
      case 'mm':
        return new Date(time)
          .getMinutes()
          .toString()
          .padStart(2, '0')
      case 'dd':
        return new Date(time)
          .getDate()
          .toString()
          .padStart(2, '0')
      case 'HH':
        return new Date(time)
          .getHours()
          .toString()
          .padStart(2, '0')
      case 'ss':
        return new Date(time)
          .getSeconds()
          .toString()
          .padStart(2, '0')
      default: {
        /**/
      }
    }
  })

/**
 * UUID生成器
 * @returns {string} uuid
 */
Vue.prototype.$UUIDHandler = () => {
  let d = new Date().getTime()

  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0

    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
